export const SERVER_MAINTENANCE_EVENT = 'serverMaintenanceChanged';

let maintenanceState = {
  active: false,
  lastChangedAt: 0,
};

export const isBrowserOffline = () => (
  typeof navigator !== 'undefined' && navigator.onLine === false
);

const emitMaintenanceState = () => {
  if (typeof window === 'undefined') return;
  window.dispatchEvent(new CustomEvent(SERVER_MAINTENANCE_EVENT, {
    detail: maintenanceState,
  }));
};

export const getServerMaintenanceState = () => {
  if (isBrowserOffline()) {
    return { active: false, lastChangedAt: maintenanceState.lastChangedAt };
  }
  return maintenanceState;
};

export const setServerMaintenanceActive = (active) => {
  if (active && isBrowserOffline()) return;
  if (maintenanceState.active === active) return;
  maintenanceState = {
    active,
    lastChangedAt: Date.now(),
  };
  emitMaintenanceState();
};

if (typeof window !== 'undefined') {
  window.addEventListener('offline', () => {
    setServerMaintenanceActive(false);
  });
}

export const isServerMaintenanceError = (error) => {
  // If the browser is offline, it is an internet connection issue, not server maintenance
  if (isBrowserOffline()) return false;

  const status = error?.response?.status;
  if (
    status === 502
    || status === 503
    || status === 504
    || (status >= 520 && status <= 524)
  ) {
    return true;
  }

  const requestUrl = error?.config?.url || '';
  const isHealthEndpoint = /\/health(?:\/?|z\/?|\/.*)?$/.test(requestUrl) || requestUrl.includes('/api/health');
  if (isHealthEndpoint && status && status >= 500 && status <= 599) return true;

  return false;
};
